module.exports = __webpack_public_path__ + "static/new-landing-e1c6bd4a0f97f638d9439a8c6fcd78a2.jpg";